import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { 
    changeOrdersInitialState, 
    handlePaginationStateOrders, 
    updateFiltersOrders, 
    resetFiltersOrders,
    setSelectedOrder,
    setShowOrderDetails
} from "../../../store/orders/ordersSlice";

const mapStateToProps = (state) => {
    return {
        // orders
        formType: state.orders.formTypeOrders,
        initialValues: state.orders.initialValuesOrders,
        showDrawer: state.orders.showDrawerOrders,
        pagination: state.orders.paginationOrders,
        filters: state.orders.filtersOrders,
        selectedOrder: state.orders.selectedOrder,
        showOrderDetails: state.orders.showOrderDetails,
    };
};

const mapDispatch = {
    changeOrdersInitialState,
    handlePaginationState: handlePaginationStateOrders,
    updateFilters: updateFiltersOrders,
    resetFilters: resetFiltersOrders,
    setSelectedOrder,
    setShowOrderDetails,
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;
